import { FaCcVisa, FaCcMastercard, FaCcAmex, FaPaypal, FaApplePay, FaGooglePay } from 'react-icons/fa';
import { SiKlarna } from 'react-icons/si';

export const PaymentMethodIcons = () => {
  return (
    <div className="space-y-3">
      <p className="text-sm text-slate-400 font-medium">Accepted payment methods</p>
      <div className="flex flex-wrap items-center gap-3">
        {/* Card Networks */}
        <div className="flex items-center gap-2 px-3 py-2 bg-slate-800/50 rounded-lg border border-slate-700/40">
          <FaCcVisa className="text-blue-400 text-2xl" aria-label="Visa" />
          <FaCcMastercard className="text-orange-400 text-2xl" aria-label="Mastercard" />
          <FaCcAmex className="text-blue-500 text-2xl" aria-label="American Express" />
        </div>

        {/* PayPal */}
        <div className="flex items-center px-3 py-2 bg-slate-800/50 rounded-lg border border-slate-700/40">
          <FaPaypal className="text-blue-400 text-2xl" aria-label="PayPal" />
        </div>

        {/* Apple Pay */}
        <div className="flex items-center px-3 py-2 bg-slate-800/50 rounded-lg border border-slate-700/40">
          <FaApplePay className="text-slate-100 text-2xl" aria-label="Apple Pay" />
        </div>

        {/* Google Pay */}
        <div className="flex items-center px-3 py-2 bg-slate-800/50 rounded-lg border border-slate-700/40">
          <FaGooglePay className="text-slate-100 text-2xl" aria-label="Google Pay" />
        </div>

        {/* Klarna */}
        <div className="flex items-center px-3 py-2 bg-slate-800/50 rounded-lg border border-slate-700/40">
          <SiKlarna className="text-pink-400 text-xl" aria-label="Klarna" />
        </div>

        {/* Clearpay */}
        <div className="flex items-center px-3 py-2 bg-slate-800/50 rounded-lg border border-slate-700/40">
          <span className="text-xs font-bold text-emerald-400 tracking-wider">CLEARPAY</span>
        </div>
      </div>
      
      <p className="text-xs text-slate-500 mt-2">
        All transactions are secure and encrypted. Buy now, pay later options available.
      </p>
    </div>
  );
};
